// 홈스쿨링 - 본사 - 지사별 통계
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import { InputGroup } from "react-bootstrap";
import { format, addDays } from "date-fns";

import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";

import CardStatContent from "../Components/CardStatContent";

const totalBase = { total: 0, playCount: 0, playCountSum: 0 };
const searchParamBase = {
    type: "",
    value: "",
};

const Content = forwardRef(({ statPeriod }, ref) => {
    const [loadingData, setLoadingData] = useState(false);
    const [stat, setStat] = useState(false);
    const [total, setTotal] = useState({ ...totalBase });
    const [tableData, setTableData] = useState(false);
    const [searchParam, setSearchParam] = useState({ ...searchParamBase });

    const defaultColDef = {
        editable: false,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };
    const listColumn = [
        {
            headerName: "No",
            field: "id",
            width: 80,
            minWidth: 50,
            valueGetter: "node.rowIndex + 1",
            pinned: "left",
        },
        {
            headerName: "콘텐츠명",
            field: "contentName",
            width: 150,
            pinned: "left",
        },
        {
            headerName: "콘텐츠ID",
            field: "contentId",
            width: 70,
        },
        {
            headerName: "메뉴",
            field: "menu",
            width: 100,
        },
        {
            headerName: "영역",
            field: "area",
            width: 100,
        },
        {
            headerName: "연령",
            field: "age",
            width: 80,
            cellRenderer: (param) => {
                return param.value == 345 ? "혼합" : `만${param.value}세`;
            },
        },
        {
            headerName: "다운로드 수",
            field: "downloadCount",
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "순 실행 수",
            field: "playCount",
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "누적 실행 수",
            field: "playCountSum",
            width: 100,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: "토모노트_콘텐츠통계",
                sheets: [
                    {
                        name: "콘텐츠",
                        title: `콘텐츠 사용 통계`,
                        columnTitle: ["콘텐츠명", "콘텐츠ID", "메뉴", `영역`, `연령`, `다운로드 수`, `순 실행 수`, `누적 실행 수`],
                        data: tableData
                            ? tableData.map((s) => [s.contentName, s.contentId, s.menu, s.area, s.age == 345 ? "혼합" : `만${s.age}세`, s.downloadCount || 0, s.playCount || 0, s.playCountSum || 0])
                            : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const initStat = () => {
        setStat(false);
        setTotal({ ...totalBase });
        setTableData(false);
        setSearchParam({ ...searchParamBase });
    };
    const getStat = () => {
        setLoadingData(true);
        initStat();
        axios({
            method: "POST",
            url: `/api/stat_note/hq/contents`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const contents = result.data.contents;
                    let total = { ...totalBase };

                    if (contents && contents.length > 0) {
                        total = contents.reduce((acc, cur) => {
                            return { playCount: (acc.playCount || 0) + cur.playCount, playCountSum: acc.playCountSum + cur.playCountSum };
                        });
                        total.total = contents.length;
                    }

                    setStat(contents);
                    setTotal(total);
                    applyData(searchParam, contents);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };
    useEffect(() => {
        getStat();
        return () => {};
    }, [statPeriod]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, stat);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
    };

    const searchField = ["contentName", "contentId"];
    const listSearch = (searchParam, list) => {
        var tableDataNew = [];
        if (!searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (item[field] && `${item[field]}`.indexOf(searchParam.value) >= 0) {
                        tableDataNew.push(item);
                    }
                });
            });
        }
        return tableDataNew;
    };

    const onRowSelected = (e) => {
        // if (onViewSubOptionSelected && e && e.data) {
        //     updateViewOption(false);
        //     onViewSubOptionSelected(e.data);
        // }
    };

    return (
        <div className="stat-branch-content">
            <div className="row mb-3">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="3" title="콘텐츠 순 실행 수" titleBgClass="bg-tomonote">
                        합계 : {total.playCount.toLocaleString()}
                    </CardStatContent>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="3" title="콘텐츠 누적 실행 수" titleBgClass="bg-tomonote">
                        합계 : {total.playCountSum.toLocaleString()}
                    </CardStatContent>
                </div>
            </div>
            <div className="row mb-1">
                <div className="col-xl-8 col-lg-7 col-md-6 col-sm-12 col-12 pl-4 d-flex">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        <span>
                            {tableData ? tableData.length.toLocaleString() : "0"} / {total.total.toLocaleString()}
                        </span>
                    </h5>
                </div>
                <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="콘텐츠명|콘텐츠ID"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <input type="submit" className="btn btn-primary" value="검색" onClick={onSearch} />
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        defaultColDef={defaultColDef}
                        columnDefs={listColumn}
                        height={550}
                        rowData={tableData}
                        onRowClicked={(e) => {
                            onRowSelected(e);
                        }}
                        pagination={true}
                        overlayNoRowsTemplate={`<span>통계 자료가 없습니다.</span>`}
                    />
                </div>
            </div>
        </div>
    );
});

export default Content;
